//@flow

export default class AuthMechanism {
  _name: string;

  constructor(name: string) {
    this._name = name;
  }

  get name(): string {
    return this._name;
  }

  toString(): string {
    return this._name;
  }

  static toEnum(val: ?string, defVal: ?AuthMechanism = null): ?AuthMechanism {
    if (val) {
      const value: string = val;
      for (let index = 0; index < AuthMechanism.values.length; index++) {
        const element: AuthMechanism = AuthMechanism.values[index];
        if (element.name.toLowerCase() === value.toLowerCase()) {
          return element;
        }
      }
    }
    return defVal;
  }

  static get values(): Array<AuthMechanism> {
    return [this.None, this.Basic, this.OAuth, this.System];
  }

  static None: AuthMechanism;
  static Basic: AuthMechanism;
  static OAuth: AuthMechanism;
  static System: AuthMechanism;
}

AuthMechanism.None = new AuthMechanism('None');
AuthMechanism.Basic = new AuthMechanism('Basic');
AuthMechanism.OAuth = new AuthMechanism('OAuth');
AuthMechanism.System = new AuthMechanism('System');

export class AuthRealm {
  /**
   * @type {string}
   * @memberof AuthRealm
   * @private
   */
  _name: string;

  /**
   * @type {AuthMechanism}
   * @memberof AuthRealm
   * @private
   */
  _authMechanism: AuthMechanism;

  /**
   *
   * @private
   * @type {string}
   * @memberof AuthRealm
   */
  _label: ?string;

  /**
   * Creates an instance of AuthRealm.
   * @param {string} name Name of the realm.
   * @param {AuthMechanism} authMechanism Mechanism for the realm.
   * @private {string} label Human readable label for this realm.
   * @memberof AuthRealm
   */
  constructor(name: string, authMechanism: AuthMechanism, label: ?string = null) {
    this._name = name;
    this._authMechanism = authMechanism;
    this._label = label;
  }

  /**
   * @readonly
   * @type {string}
   * @memberof AuthRealm
   * @returns {string}
   */
  get name(): string {
    return this._name;
  }

  /**   
   * @readonly
   * @type {AuthMechanism}
   * @memberof AuthRealm
    @returns {AuthMechanism}
   */
  get authMechanism(): AuthMechanism {
    return this._authMechanism;
  }

  /**
   * Note: It can be null.
   * @readonly
   * @type {string|null|undefined}
   * @memberof AuthRealm
   */
  get label(): ?string {
    return this._label;
  }

  toString() {
    return this._name;
  }
}

//export const ZOOM_EXTERNAL_REALM: AuthRealm = new AuthRealm('ZoomExternal', AuthMechanism.Basic);
//export const ZOOM_REALM: AuthRealm = new AuthRealm('ZoomRealm', AuthMechanism.Basic);
export const NULL_BASIC_REALM: AuthRealm = new AuthRealm('', AuthMechanism.Basic);
export const NULL_OAUTH_REALM: AuthRealm = new AuthRealm('', AuthMechanism.OAuth);
